var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-content',{attrs:{"with_go_back_bar":""}},[_c('kt-panel',[(_vm.status !== 'loading')?_c('kt-panel-body',[_c('product-form',{attrs:{"submit":_vm.updateProduct,"query":_vm.product}})],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }